import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormArray, Validators, FormControl, FormBuilder } from '@angular/forms';
import { Contact } from '../../models/contact';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MasterService } from '../../services/master.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-email-type',
  templateUrl: './email-type.component.html',
  styleUrls: ['./email-type.component.css']
})
export class EmailTypeComponent implements OnInit {
  emailtypeList = [];
  @Input() contactForm: FormGroup;
  emailFormArray: FormArray;
  @Input() contactFilter: string[];
  @Input() formGroupNanme: string;
  index = -1;
  @Input() commonContact: any;
  tempData = [];
  rowCount = 1;
  emailIds = [];
  filterOptionsList = [];
  seletected = [];
  objemail = {
    lookupId: 478,
    contactId: 0,
    emailConfigTransId: 0,
    contactData: '',
    active: true,
    emailDestLookupId: 0,
    emailDestName: '',
    createdUserId: 0,
  };
  existItem = [];
  contact: Contact = new Contact();
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, private common: CommonService) { }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      if (changes.commonContact) {
        if (this.commonContact) {
          // console.log(this.commonContact.contact, 'this.commonContact.contact');
          this.initForm();
          const frmGrp = this.contactForm.get(this.formGroupNanme) as FormGroup;
          const contactfrmgrp = frmGrp.get('contact') as FormArray;
          if (this.commonContact.contact) {
            for (let i = 0; this.commonContact.contact.length > i; i++) {
              contactfrmgrp.push(this.initcontact());
            }
          }
          if (this.commonContact.contact) {
            this.emailIds = this.commonContact.contact;
            contactfrmgrp.setValue(this.emailIds);
          }
        }
      }
    }, 100);

  }

  ngOnInit() {
    this.getContactLookup();
    this.initForm();
    // this.addItem();
  }
  initForm() {
    const frmGrp = this.contactForm.get(this.formGroupNanme) as FormGroup;
    frmGrp.addControl('emailaddress', new FormControl(''));
    frmGrp.addControl('emailDestLookupId', new FormControl(''));
    frmGrp.addControl('contact', this.formBuilder.array([]));
  }
  initcontact(): FormGroup {
    return this.formBuilder.group({
      contactId: new FormControl(0),
      emailConfigTransId: new FormControl(0),
      contactData: new FormControl(),
      active: new FormControl(true),
      lookupId: new FormControl(478),
      emailDestLookupId: new FormControl(),
      emailDestName: new FormControl(),
      createdUserId: new FormControl(0)
    });
  }
  getContactLookup() {
    this.masterService.getEmailDestination().subscribe(res => {
      if (res) {
        this.tempData = res;
        this.emailtypeList = res;
      }
    });
  }
  add(): void {
    // this.emailFormArray = this.contactForm.get(this.contactformGroupName) as FormArray;
    const frmgroup = this.contactForm.get(this.formGroupNanme) as FormGroup;
    const control = frmgroup.get('emailaddress');
    const contactfrmgrp = frmgroup.get('contact') as FormArray;
    if (frmgroup.get('emailDestLookupId').value) {
      if (control.value) {
        const exist = this.emailIds.some((s, index) =>
          s.contactData === control.value && index !== this.index);
        if (exist) {
          control.setErrors({ alreadyExist: true });
        } else {
          if (this.index > -1) {
            this.emailIds[this.index].contactData = control.value;
            this.emailIds[this.index].emailDestLookupId = frmgroup.get('emailDestLookupId').value;
          } else {
            const temobjPhone = this.common.CloneObject(this.objemail);
            temobjPhone.contactData = control.value;
            temobjPhone.emailDestLookupId = frmgroup.get('emailDestLookupId').value;
            this.emailIds.push(temobjPhone);
            contactfrmgrp.push(this.initcontact());
          }
          contactfrmgrp.setValue(this.emailIds);
          control.reset();
          frmgroup.get('emailDestLookupId').setValue('');
          this.index = -1;
          frmgroup.get('emailDestLookupId').clearValidators();
          frmgroup.get('emailDestLookupId').markAsUntouched();
          frmgroup.get('emailDestLookupId').updateValueAndValidity();
          control.clearValidators();
          control.markAsUntouched();
          control.updateValueAndValidity();
        }
      } else {
        control.setValidators(Validators.required);
        control.markAsTouched();
        control.updateValueAndValidity();
      }
    } else {
      // this.contactForm.get(this.contactformGroupName['lookupId']).setValidators(Validators.required);
      frmgroup.get('emailDestLookupId').setValidators(Validators.required);
      frmgroup.get('emailDestLookupId').markAsTouched();
      frmgroup.get('emailDestLookupId').updateValueAndValidity();
    }
  }
  getEmailType(lookupId): string {
    const lookUp = this.emailtypeList.find(f => f.lookUpId === lookupId);
    if (lookUp) {
      return lookUp.lookUpName;
    } else {
      return '';
    }
  }
  editEmail(index) {
    this.index = index;
    const frmgroup = this.contactForm.get(this.formGroupNanme) as FormGroup;
    const control = frmgroup.get('emailaddress');
    frmgroup.get('emailDestLookupId').setValue(this.emailIds[index].emailDestLookupId);
    control.setValue(this.emailIds[index].contactData);
  }
  removeControl(data: any) {
    const frmgroup = this.contactForm.get(this.formGroupNanme) as FormGroup;
    const contactfrmgrp = frmgroup.get('contact') as FormArray;
    contactfrmgrp.removeAt(data);
    this.emailIds.splice(data);
    this.index = -1;
  }
}
